import axios from "axios";
import { ulid } from "ulid";

const DEBOUNCE_DELAY = 1500;
let debounceTimer = null;

export const saveUserPreferencesDebounced = (
  preferencesId,
  userEmailValue,
  favoriteTemplatesIds,
  favoriteDatasetsIds,
  newHomepageEnabled,
  darkModeEnabled
) => {
  if (debounceTimer) {
    clearTimeout(debounceTimer);
  }

  debounceTimer = setTimeout(async () => {
    try {
      const payload = {
        id: preferencesId || ulid(),
        userEmail: userEmailValue,
        favoriteTemplatesIds: favoriteTemplatesIds || [],
        favoriteDatasetsIds: favoriteDatasetsIds || [],
        newHomepageEnabled: newHomepageEnabled || false,
        darkModeEnabled: darkModeEnabled || false,
      };

      await axios.post(`${process.env.REACT_APP_API_ENDPOINT}/api/UserPreferences`, payload);
    } catch (error) {
      console.error("Failed to sync favorites to backend:", error);
    }
  }, DEBOUNCE_DELAY);
};
